export const dataExample = {
  'data': {
    "doctors": [
      {
        "id": 1,
        "name": "院長",
        "bgcolor": "#85C1E9",
        "fontcolor": "#566573",
        "displayorder": "1.00"
      },
      {
        "id": 2,
        "name": "副院長",
        "bgcolor": "#82E0AA",
        "fontcolor": "#566573",
        "displayorder": "2.00"
      },
      {
        "id": 3,
        "name": "美容外科医A",
        "bgcolor": "#F9E79F",
        "fontcolor": "#566573",
        "displayorder": "3.00"
      },
      {
        "id": 4,
        "name": "美容外科医B",
        "bgcolor": "#F0B27A",
        "fontcolor": "#566573",
        "displayorder": "4.00"
      },
      {
        "id": 5,
        "name": "アートメイク",
        "bgcolor": "#F5A9E1",
        "fontcolor": "#566573",
        "displayorder": "5.00"
      }
    ],
    "days": [
      {
        "day": "2024-11-01",
        "colspan": 2,
        "doctors": [
          {
            "id": 3,
            "name": "美容外科医A",
            "day": "2024-11-02"
          },
          {
            "id": 4,
            "name": "美容外科医B",
            "day": "2024-11-01"
          }
        ]
      },
      {
        "day": "2024-11-02",
        "colspan": 2,
        "doctors": [
          {
            "id": 3,
            "name": "美容外科医A",
            "day": "2024-11-02"
          },
          {
            "id": 4,
            "name": "美容外科医B",
            "day": "2024-11-02"
          }
        ]
      },
      {
        "day": "2024-11-04",
        "colspan": 2,
        "doctors": [
          {
            "id": 3,
            "name": "美容外科医A",
            "day": "2024-11-04"
          },
          {
            "id": 4,
            "name": "美容外科医B",
            "day": "2024-11-04"
          }
        ]
      },
      {
        "day": "2024-11-05",
        "colspan": 2,
        "doctors": [
          {
            "id": 3,
            "name": "美容外科医A",
            "day": "2024-11-05"
          },
          {
            "id": 4,
            "name": "美容外科医B",
            "day": "2024-11-05"
          }
        ]
      },
      {
        "day": "2024-11-06",
        "colspan": 2,
        "doctors": [
          {
            "id": 3,
            "name": "美容外科医A",
            "day": "2024-11-06"
          },
          {
            "id": 4,
            "name": "美容外科医B",
            "day": "2024-11-06"
          }
        ]
      }
    ],
    "times": [
      {
        "show": 1,
        "hm": "08:30",
        "columns": [
          {
            "text": [
              {
                "value": "time",
                "label": "8:30"
              }
            ]
          },
          {
            "text": {
              "kana": "田中 櫻子",
              "fullname": "たなか さくらこ",
              "age": "(34歳)",
              "starttime": "08:45〜",
              "task": [
                {
                  "text": '骨',
                  "value": 1
                },
                {
                  "text": 'Twojaw',
                  "value": 1
                },
                {
                  "text": 'N修正',
                  "value": 1
                },
                {
                  "text": '複合',
                  "value": 1
                },
                {
                  "text": 'FL',
                  "value": 0
                },
              ]
            },
            "id": 26929,
            "warning": 1,
            "patientid": "",
            "privacy": 0,
            "starttime": "08:30",
            "rowspan": 6,
            "color": {
              "bg": "#FFF4E5",
              "font": "#000"
            },
            "daylastcol": 0,
            "index": 0
          },
          {
            "daylastcol": 1,
            "index": 1
          },
          {
            "index": 2
          },
          {
            "daylastcol": 1,
            "index": 3
          },
          {
            "index": 4
          },
          {
            "daylastcol": 1,
            "index": 5
          },
          {
            "index": 6
          },
          {
            "daylastcol": 1,
            "index": 7
          },
          {
            "index": 8
          },
          {
            "daylastcol": 1,
            "index": 9
          },
        ]
      },
      {
        "show": 0,
        "hm": "08:35",
        "columns": [
          {
            "text": [
              {
                "value": "time",
                "label": ""
              }
            ]
          },
          {
            "daylastcol": 1,
            "index": 1
          },
          {
            "index": 2
          },
          {
            "daylastcol": 1,
            "index": 3
          },
          {
            "index": 4
          },
          {
            "daylastcol": 1,
            "index": 5
          },
          {
            "index": 6
          },
          {
            "daylastcol": 1,
            "index": 7
          },
          {
            "index": 8
          },
          {
            "daylastcol": 1,
            "index": 9
          },
        ]
      },
      {
        "show": 0,
        "hm": "08:40",
        "columns": [
          {
            "text": [
              {
                "value": "time",
                "label": ""
              }
            ]
          },
          {
            "daylastcol": 1,
            "index": 1
          },
          {
            "index": 2
          },
          {
            "daylastcol": 1,
            "index": 3
          },
          {
            "index": 4
          },
          {
            "daylastcol": 1,
            "index": 5
          },
          {
            "index": 6
          },
          {
            "daylastcol": 1,
            "index": 7
          },
          {
            "index": 8
          },
          {
            "daylastcol": 1,
            "index": 9
          },
        ]
      },
      {
        "show": 0,
        "hm": "08:45",
        "columns": [
          {
            "text": [
              {
                "value": "time",
                "label": ""
              }
            ]
          },
          {
            "daylastcol": 1,
            "index": 1
          },
          {
            "index": 2
          },
          {
            "daylastcol": 1,
            "index": 3
          },
          {
            "index": 4
          },
          {
            "daylastcol": 1,
            "index": 5
          },
          {
            "index": 6
          },
          {
            "daylastcol": 1,
            "index": 7
          },
          {
            "index": 8
          },
          {
            "daylastcol": 1,
            "index": 9
          },
        ]
      },
      {
        "show": 0,
        "hm": "08:50",
        "columns": [
          {
            "text": [
              {
                "value": "time",
                "label": ""
              }
            ]
          },
          {
            "daylastcol": 1,
            "index": 1
          },
          {
            "index": 2
          },
          {
            "daylastcol": 1,
            "index": 3
          },
          {
            "index": 4
          },
          {
            "daylastcol": 1,
            "index": 5
          },
          {
            "index": 6
          },
          {
            "daylastcol": 1,
            "index": 7
          },
          {
            "index": 8
          },
          {
            "daylastcol": 1,
            "index": 9
          },
        ]
      },
      {
        "show": 0,
        "hm": "08:55",
        "columns": [
          {
            "text": [
              {
                "value": "time",
                "label": ""
              }
            ]
          },
          {
            "daylastcol": 1,
            "index": 1
          },
          {
            "index": 2
          },
          {
            "daylastcol": 1,
            "index": 3
          },
          {
            "index": 4
          },
          {
            "daylastcol": 1,
            "index": 5
          },
          {
            "index": 6
          },
          {
            "daylastcol": 1,
            "index": 7
          },
          {
            "index": 8
          },
          {
            "daylastcol": 1,
            "index": 9
          },
        ]
      },

      {
        "show": 1,
        "hm": "09:00",
        "columns": [
          {
            "text": [
              {
                "value": "time",
                "label": "9:00"
              }
            ]
          },
          {
            "index": 0
          },
          {
            "text": {
              "kana": "田中 櫻子",
              "fullname": "たなか さくらこ",
              "age": "(34歳)",
              "starttime": "08:45〜",
              "task": [
                {
                  "text": '骨',
                  "value": 1
                },
                {
                  "text": 'Twojaw',
                  "value": 1
                },
                {
                  "text": 'N修正',
                  "value": 1
                },
                {
                  "text": '複合',
                  "value": 1
                },
                {
                  "text": 'FL',
                  "value": 0
                },
              ]
            },
            "id": 26929,
            "warning": 0,
            "patientid": "",
            "privacy": 0,
            "starttime": "09:00",
            "rowspan": 6,
            "color": {
              "bg": "#FFF4E5",
              "font": "#000"
            },
            "daylastcol": 1,
            "index": 1
          },
          {
            "index": 2
          },
          {
            "daylastcol": 1,
            "index": 3
          },
          {
            "index": 4
          },
          {
            "daylastcol": 1,
            "index": 5
          },
          {
            "index": 6
          },
          {
            "daylastcol": 1,
            "index": 7
          },
          {
            "index": 8
          },
          {
            "daylastcol": 1,
            "index": 9
          },
        ]
      },
      {
        "show": 0,
        "hm": "09:05",
        "columns": [
          {
            "text": [
              {
                "value": "time",
                "label": ""
              }
            ]
          },
          {
            "index": 0
          },
          {
            "index": 2
          },
          {
            "daylastcol": 1,
            "index": 3
          },
          {
            "index": 4
          },
          {
            "daylastcol": 1,
            "index": 5
          },
          {
            "index": 6
          },
          {
            "daylastcol": 1,
            "index": 7
          },
          {
            "index": 8
          },
          {
            "daylastcol": 1,
            "index": 9
          },
        ]
      },
      {
        "show": 0,
        "hm": "09:10",
        "columns": [
          {
            "text": [
              {
                "value": "time",
                "label": ""
              }
            ]
          },
          {
            "index": 0
          },
          {
            "index": 2
          },
          {
            "daylastcol": 1,
            "index": 3
          },
          {
            "index": 4
          },
          {
            "daylastcol": 1,
            "index": 5
          },
          {
            "index": 6
          },
          {
            "daylastcol": 1,
            "index": 7
          },
          {
            "index": 8
          },
          {
            "daylastcol": 1,
            "index": 9
          },
        ]
      },
      {
        "show": 0,
        "hm": "09:15",
        "columns": [
          {
            "text": [
              {
                "value": "time",
                "label": ""
              }
            ]
          },
          {
            "index": 0
          },
          {
            "index": 2
          },
          {
            "daylastcol": 1,
            "index": 3
          },
          {
            "index": 4
          },
          {
            "daylastcol": 1,
            "index": 5
          },
          {
            "index": 6
          },
          {
            "daylastcol": 1,
            "index": 7
          },
          {
            "index": 8
          },
          {
            "daylastcol": 1,
            "index": 9
          },
        ]
      },
      {
        "show": 0,
        "hm": "09:20",
        "columns": [
          {
            "text": [
              {
                "value": "time",
                "label": ""
              }
            ]
          },
          {
            "index": 0
          },
          {
            "index": 2
          },
          {
            "daylastcol": 1,
            "index": 3
          },
          {
            "index": 4
          },
          {
            "daylastcol": 1,
            "index": 5
          },
          {
            "index": 6
          },
          {
            "daylastcol": 1,
            "index": 7
          },
          {
            "index": 8
          },
          {
            "daylastcol": 1,
            "index": 9
          },
        ]
      },
      {
        "show": 0,
        "hm": "09:25",
        "columns": [
          {
            "text": [
              {
                "value": "time",
                "label": ""
              }
            ]
          },
          {
            "index": 0
          },
          {
            "index": 2
          },
          {
            "daylastcol": 1,
            "index": 3
          },
          {
            "index": 4
          },
          {
            "daylastcol": 1,
            "index": 5
          },
          {
            "index": 6
          },
          {
            "daylastcol": 1,
            "index": 7
          },
          {
            "index": 8
          },
          {
            "daylastcol": 1,
            "index": 9
          },
        ]
      },

      {
        "show": 1,
        "hm": "09:30",
        "columns": [
          {
            "text": [
              {
                "value": "time",
                "label": "9:30"
              }
            ]
          },
          {
            "index": 0
          },
          {
            "daylastcol": 1,
            "index": 1
          },
          {
            "index": 2
          },
          {
            "text": {
              "kana": "田中 櫻子",
              "fullname": "たなか さくらこ",
              "age": "(34歳)",
              "starttime": "08:45〜",
              "task": [
                {
                  "text": '骨',
                  "value": 1
                },
                {
                  "text": 'Twojaw',
                  "value": 1
                },
                {
                  "text": 'N修正',
                  "value": 1
                },
                {
                  "text": '複合',
                  "value": 1
                },
                {
                  "text": 'FL',
                  "value": 0
                },
              ]
            },
            "id": 26929,
            "warning": 1,
            "patientid": "",
            "privacy": 0,
            "starttime": "09:30",
            "rowspan": 6,
            "color": {
              "bg": "#FFF4E5",
              "font": "#000"
            },
            "daylastcol": 1,
            "index": 3
          },
          {
            "index": 4
          },
          {
            "daylastcol": 1,
            "index": 5
          },
          {
            "index": 6
          },
          {
            "daylastcol": 1,
            "index": 7
          },
          {
            "index": 8
          },
          {
            "daylastcol": 1,
            "index": 9
          },
        ]
      },
      {
        "show": 0,
        "hm": "09:35",
        "columns": [
          {
            "text": [
              {
                "value": "time",
                "label": ""
              }
            ]
          },
          {
            "index": 0
          },
          {
            "daylastcol": 1,
            "index": 1
          },
          {
            "index": 2
          },
          {
            "index": 4
          },
          {
            "daylastcol": 1,
            "index": 5
          },
          {
            "index": 6
          },
          {
            "daylastcol": 1,
            "index": 7
          },
          {
            "index": 8
          },
          {
            "daylastcol": 1,
            "index": 9
          },
        ]
      },
      {
        "show": 0,
        "hm": "09:35",
        "columns": [
          {
            "text": [
              {
                "value": "time",
                "label": ""
              }
            ]
          },
          {
            "index": 0
          },
          {
            "daylastcol": 1,
            "index": 1
          },
          {
            "index": 2
          },
          {
            "index": 4
          },
          {
            "daylastcol": 1,
            "index": 5
          },
          {
            "index": 6
          },
          {
            "daylastcol": 1,
            "index": 7
          },
          {
            "index": 8
          },
          {
            "daylastcol": 1,
            "index": 9
          },
        ]
      },
      {
        "show": 0,
        "hm": "09:35",
        "columns": [
          {
            "text": [
              {
                "value": "time",
                "label": ""
              }
            ]
          },
          {
            "index": 0
          },
          {
            "daylastcol": 1,
            "index": 1
          },
          {
            "index": 2
          },
          {
            "index": 4
          },
          {
            "daylastcol": 1,
            "index": 5
          },
          {
            "index": 6
          },
          {
            "daylastcol": 1,
            "index": 7
          },
          {
            "index": 8
          },
          {
            "daylastcol": 1,
            "index": 9
          },
        ]
      },
      {
        "show": 0,
        "hm": "09:35",
        "columns": [
          {
            "text": [
              {
                "value": "time",
                "label": ""
              }
            ]
          },
          {
            "index": 0
          },
          {
            "daylastcol": 1,
            "index": 1
          },
          {
            "index": 2
          },
          {
            "index": 4
          },
          {
            "daylastcol": 1,
            "index": 5
          },
          {
            "index": 6
          },
          {
            "daylastcol": 1,
            "index": 7
          },
          {
            "index": 8
          },
          {
            "daylastcol": 1,
            "index": 9
          },
        ]
      },
      {
        "show": 0,
        "hm": "09:35",
        "columns": [
          {
            "text": [
              {
                "value": "time",
                "label": ""
              }
            ]
          },
          {
            "index": 0
          },
          {
            "daylastcol": 1,
            "index": 1
          },
          {
            "index": 2
          },
          {
            "index": 4
          },
          {
            "daylastcol": 1,
            "index": 5
          },
          {
            "index": 6
          },
          {
            "daylastcol": 1,
            "index": 7
          },
          {
            "index": 8
          },
          {
            "daylastcol": 1,
            "index": 9
          },
        ]
      },
    ]
  }
}